import React from 'react';

export const SpendInSearchColumn = ({ i18n }) => ({
  key: 'SpendInSearch',
  name: i18n.getString(_TL_('Spending in Search')),
  fieldName: 'SpendInSearch',
  className: 'column-spend-in-search',
  headerClassName: 'header-spend-in-search',
  helpTopic: 'Pop_BA_SearchInsights_Keywords',
  minWidth: 180,
  sortable: true,
  isMultiline: true,
  isResizable: true,
  onRender: item => (
    <span>
      {item.SpendInSearch}
    </span>
  ),
});
